export enum ReservationErrorEnum {
  FULLY_BOOKED_PARK = 'FULLY_BOOKED_PARK',
  INVALID_LICENSE_PLATE_OR_ENGINE_TYPE = 'INVALID_LICENSE_PLATE_OR_ENGINE_TYPE',
  MINIMUM_CAPACITY = 'MINIMUM_CAPACITY',
}
